import {
  SavePasswordDocument,
  SavePasswordMutation,
  SavePasswordMutationVariables,
} from "@graphql/api";

interface SavePasswordReturn {
  success: boolean;
  errorMessage?: string;
}

export default async function savePasswordWithPid(
  currentPassword: string,
  newPassword: string,
): Promise<SavePasswordReturn> {
  const client = global.window.apolloClient;
  const mutVars: SavePasswordMutationVariables = { currentPassword, newPassword };
  const result = await client.mutate<SavePasswordMutation, SavePasswordMutationVariables>({
    mutation: SavePasswordDocument,
    variables: mutVars,
  });

  if (!result.data?.savePassword) {
    return {
      success: false,
      errorMessage: "Failed to save password",
    };
  }

  return {
    success: result.data.savePassword.success,
    errorMessage: result.data.savePassword.errorMessage ?? undefined,
  };
}
